<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-form ref="facilityForm" v-model="isFormValid">
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-text-field
                outlined
                dense
                hide-details
                v-model.trim="facilityData.name"
                label="Facility name"
                :counter="50"
                :rules="requiredRule"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                outlined
                dense
                hide-details
                v-model.trim="facilityData.contactInfo"
                label="Contact info"
                :counter="50"
                :rules="requiredRule"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                outlined
                dense
                hide-details
                v-model.trim="facilityData.urlToDetails"
                label="Url to details"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                outlined
                dense
                hide-details
                v-model.trim="facilityData.city"
                label="City"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                outlined
                dense
                hide-details
                type="number"
                v-model.number="facilityData.latitude"
                :rules="requiredRule"
                label="Facility latitude"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                outlined
                dense
                hide-details
                type="number"
                v-model.number="facilityData.longitude"
                :rules="requiredRule"
                label="Facility longitude"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <SelectByCategory
                @value-change="facilityData.countryId = +$event"
                :isRequired="true"
                selectItemText="node.valName"
                selectItemValue="node.valId"
                categoryName="COUNTRY_LIST"
                labelName="Facility country"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <SelectByCategory
                @value-change="facilityData.type = $event"
                :isRequired="true"
                selectItemText="node.valName"
                selectItemValue="node.valName"
                categoryName="FACILITY"
                labelName="Facility type"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                outlined
                hide-details
                dense
                :items="['active', 'inactive']"
                v-model="facilityData.state"
                label="Facility state"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <SelectLeague
                @value-change="facilityData.leagueSeqno = +$event"
                :isRequired="true"
                selectItemText="node.name"
                selectItemValue="node.seqno"
                labelName="Select league"
              />
            </v-flex>
            <v-flex xs12>
              <v-autocomplete
                v-model="currentAddress"
                :items="address"
                dense
                cache-items
                :loading="searchLoading"
                :search-input.sync="facilityData.address"
                clearable
                :rules="requiredRule"
                hide-selected
                label="Set facility address"
                outlined
                hint="You may need to wait for address searching"
                :persistent-hint="true"
                no-data-text="Search address"
                item-value="raw"
                item-text="label"
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      Searching for your
                      <strong>address</strong>
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                outlined
                dense
                hide-details
                v-model.trim="facilityData.desc"
                label="Facility description"
                required
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" text @click="close">Cancel</v-btn>
      <v-btn :disabled="!isFormValid" color="secondary" text @click="actionName"
        >Save</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
// import { meetDefaultData } from "@/constants/tabelsData";
// import { validationRules } from "@/constants/global";
// //TODO Fix filter problem in component below
// import catValueDropDown from "../shared/cat_val_dropdown.vue";
// import { mapGetters, mapActions } from "vuex";
// import { hasJsonStructure } from "@/_helpers/index";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import { validation } from "@/mixins/validationMixin";
import SelectByCategory from "@/components/shared/SelectByCategory.vue";
import SelectLeague from "@/components/shared/SelectLeague.vue";

export default {
  components: { SelectByCategory, SelectLeague },
  mixins: [validation],
  props: {
    index: {
      type: [Boolean, Number],
      default: () => -1
    },
    latLng: {
      type: [Object, String, Boolean],
      default: () => {
        return {
          latitude: 0,
          longitude: 0
        };
      }
    }
  },
  mounted() {
    if (this.latLng && this.latLng.latitude && this.latLng.longitude) {
      this.facilityData.latitude = this.latLng.latitude;
      this.facilityData.longitude = this.latLng.longitude;
    }
  },
  data() {
    return {
      address: [],
      currentAddress: "",
      searchLoading: false,
      isFormValid: true,
      facilityData: {
        name: "",
        desc: "",
        contactInfo: "",
        urlToDetails: "",
        type: "",
        state: "",
        city: "",
        countryId: "",
        latitude: "",
        longitude: "",
        tag: "",
        address: "",
        leagueSeqno: "",
        updateSource: "test"
      },
      defaultFacilityData: {
        name: "",
        desc: "",
        contactInfo: "",
        urlToDetails: "",
        type: "",
        state: "",
        city: "",
        countryId: "",
        latitude: "",
        longitude: "",
        tag: "",
        address: "",
        leagueSeqno: "",
        updateSource: "test"
      }
    };
  },
  watch: {
    // currentAddress(val) {
    //   if (val && val.display_name !== null) {
    //     this.meetData.meetAddress = val.display_name;
    //     this.meetData.latitude = val.lat;
    //     this.meetData.longitude = val.lon;
    //     console.log(val);
    //   }
    // },
    "facilityData.address"(val) {
      // Items have already been loaded
      // if (this.address.length > 0) return;

      this.searchLoading = true;
      const provider = new OpenStreetMapProvider();
      provider
        .search({
          query: val
        })
        .then(data => {
          this.address = data;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.searchLoading = false;
        });
    }
  },
  computed: {
    formTitle() {
      return this.index > 0 ? "Edit facility" : "Add facility";
    },
    actionName() {
      return this.index > 0 ? this.editFacility : this.addFacility;
    }
  },
  methods: {
    close() {
      this.$emit("close-form");
      this.facilityData = Object.assign({}, this.defaultFacilityData);
      this.address = [];
      this.currentAddress = "";
    },
    editFacility() {},
    addFacility() {
      // add user id to mutation
      // convert latitude and long to float with 4 digits
      if (this.isFormValid) {
        this.$store.commit("setLoadingDialog", true);
        this.$store
          .dispatch("addFacility", {
            ...this.facilityData,
            latitude: +this.facilityData.latitude.toFixed(4),
            longitude: +this.facilityData.longitude.toFixed(4),
            userId: this.$store.getters.user
              ? +this.$store.getters.user.userId
              : null
          })
          .then(() => {
            this.$toast.success("Facility has been added");
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.$store.commit("setLoadingDialog", false);
            this.close();
          });
      }
    }
  }
};
</script>
